import { Flex } from "antd";
import { getClassNames } from "@/shared/utils";
import type { ReactNode } from "react";
import styles from "./styles.module.scss";

type Props = {
  title: string;
  className?: string;
  button?: ReactNode;
};

export const SettingsSectionTitle = ({ title, className, button }: Props) => {
  return (
    <Flex
      justify="space-between"
      align="center"
      className={getClassNames(
        styles.title,
        className,
        Boolean(button) && styles["title--with-button"],
      )}
    >
      <p>{title}</p>
      {button}
    </Flex>
  );
};
